import { HOST } from "../../config/urls"

export const localFetch = async (url: string, body?: RequestInit) => {
  const res = await fetch(`${HOST}${url}`, {
    ...body,
    credentials: "include",
  })

  if (res.status === 401) {
    window.location.href = "/"
  }

  return res
}
